// src/app/components/login.component.ts
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  error = '';

  // Hardcoded credentials
  private readonly VALID_USERNAME = 'DiginuEV';
  private readonly VALID_PASSWORD = 'Diginu@evpilot';

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  // Convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.error = '';

    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;

    const { username, password } = this.loginForm.value;
    
    // Use setTimeout to simulate an API call if needed
    setTimeout(() => {
      // Call the AuthService login method directly
      const success = this.authService.login(username, password);
      
      console.log('Login result:', success);
      
      if (success) {
        this.router.navigate(['/overview/vehicles-overview']);
      } else {
        this.error = 'Invalid username or password';
      }
      
      this.loading = false;
    }, 1000);
  }
}